import * as types from "./intlActionTypes";
import intlInitialState from "./intlInitialState";
import { flattenMessages } from "./intlUtils";

import messages from "./messages";

export default function intlReducer(state = intlInitialState.intl, action) {
  switch (action.type) {
    case types.SET_LOCALE: {
      return {
        ...state,
        locale: action.locale,
        messages: flattenMessages(messages[action.locale]),
      };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/intl/intlReducer.js